import React from 'react';
import { useRole } from '../contexts/RoleContext';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';

const AccessDenied = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
    <Paper sx={{ p: 5, textAlign: 'center', maxWidth: 400 }}>
      <LockIcon sx={{ fontSize: 56, color: 'text.disabled', mb: 2 }} />
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>Access Denied</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        You don't have permission to access this page. Contact your administrator for access.
      </Typography>
      <Button variant="contained" href="/dashboard">Go to Dashboard</Button>
    </Paper>
  </Box>
);

const ProtectedRoute = ({ children, path }) => {
  const { hasAccess } = useRole();

  if (!hasAccess(path)) {
    return <AccessDenied />;
  }

  return children;
};

export default ProtectedRoute;
